export const handleContactClick = (action, label) => {
  if (action === '_blank') {
    return window.open(`https://${label}`, action);
  }

  window.location.href = `${action}:${label}`;

  return null;
};
